module.exports = __webpack_public_path__ + "img/logo-light.e9dc1a70.png";